import { ReactNode } from "react"

import {
  Header,
  HeaderContent,
  HeaderDescription,
  HeaderRightContent,
  HeaderRow,
  HeaderTitle,
} from "@/components/ds/Header"
import { Typography } from "@/components/ds/Typography"
import { cn } from "@/lib/utils"

export interface PostLoginHeaderProps {
  heading: ReactNode
  smallHeading?: ReactNode
  headingClassName?: string
  smallHeadingClassName?: string
  breadcrumb?: ReactNode
  description?: ReactNode
  rightContent?: ReactNode
  /**
   * Extra classes for the title/right-content row only.
   *
   * That row does not wrap by default, so intrinsically sized `rightContent` can
   * overflow at narrow widths. Optional and unset by default, so every existing
   * header keeps exactly the layout it has.
   */
  topRowClassName?: string
  className?: string
  children?: ReactNode
}

export default function PostLoginHeader({
  heading,
  smallHeading,
  headingClassName,
  smallHeadingClassName,
  breadcrumb,
  description,
  rightContent,
  topRowClassName,
  className,
  children,
}: PostLoginHeaderProps) {
  return (
    <Header className={cn("mb-6", className)}>
      <HeaderRow className={topRowClassName}>
        <HeaderContent>
          {breadcrumb}
          {smallHeading && (
            <Typography variant="body1" className={`leading-5 text-neutral-text ${smallHeadingClassName ?? ""}`}>
              {smallHeading}
            </Typography>
          )}
          <HeaderTitle className={headingClassName}>{heading}</HeaderTitle>
        </HeaderContent>

        {rightContent && <HeaderRightContent>{rightContent}</HeaderRightContent>}
      </HeaderRow>

      {description && (
        <HeaderRow>
          <HeaderDescription>{description}</HeaderDescription>
        </HeaderRow>
      )}

      {children}
    </Header>
  )
}
